// extracted by mini-css-extract-plugin
export default {"card":"_2y0ZoDj7lgZhADz1XRs5Yo"};